export default __webpack_public_path__ + "static/iketchak-4a8299ca24fa9276d5dc0328ebfd2c5c.png";